var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgReflectHorizontal = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 20,
  height: 20,
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M10 2C10.4156 2 10.75 2.33437 10.75 2.75V17.25C10.75 17.6656 10.4156 18 10 18C9.58437 18 9.25 17.6656 9.25 17.25V2.75C9.25 2.33437 9.58437 2 10 2ZM3.5 7.20625V12.7906L6.29375 10L3.5 7.20625ZM2 6C2 5.59687 2.24375 5.23125 2.61875 5.075C2.99375 4.91875 3.42188 5.00625 3.70938 5.29063L7.70937 9.29063C8.1 9.68125 8.1 10.3156 7.70937 10.7063L3.70938 14.7063C3.42188 14.9938 2.99375 15.0781 2.61875 14.9219C2.24375 14.7656 2 14.4031 2 14V6ZM13.7063 10L16.5 12.7937V7.20937L13.7063 10ZM17.3813 5.075C17.7563 5.23125 18 5.59375 18 6V14C18 14.4031 17.7563 14.7688 17.3813 14.925C17.0063 15.0813 16.5781 14.9938 16.2906 14.7094L12.2906 10.7094C11.9 10.3188 11.9 9.68437 12.2906 9.29375L16.2906 5.29375C16.5781 5.00625 17.0063 4.92188 17.3813 5.07812V5.075Z",
  fill: "#F8F9FA"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgReflectHorizontal);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "f9f16656519fac1edeef784c721e9446.svg";